import booleanValid from '@turf/boolean-valid';
import kinks from '@turf/kinks';
import type {Polygon} from 'geojson';

/**
 * Check if a polygon
 * @param geometry GeoJSON Polygon to validate
 * @returns true if the polygon is valid and contains no self-intersections, otherwise false
 */
export default function isPolygonValid(geometry?: Polygon | undefined) {
    if (!geometry) return false;

    if (!geometry.coordinates) return false;

    if (!booleanValid(geometry)) return false;

    const {features: selfIntersections} = kinks(geometry);

    if (selfIntersections.length > 0) return false;

    return true;
}
